import { css } from 'styled-components'

export default css`
  position: relative;
  flex-shrink: 0;

  .payment-history-vendor-handle {
    .vendor-icon {
      flex-shrink: 0;
    }

    .vendor-label {
      max-width: 180px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .chevron {
      transform: rotate(180deg);
      transition: transform 200ms ease-out;

      &.open {
        transform: rotate(0deg);
      }
    }
  }

  .payment-history-vendor-empty {
    padding: 12px 16px;
  }
`
